import React, { useState } from "react";
import "./CommonInputField.css";
import { CommonDropdown } from "../CommonDropDown/CommonDropDown";
import { CommonMultipleDropdown } from "../CommonDropDown/CommonMutipleDropdown";

const CommonInputField = (props) => {
  const handleDelete = (skillToDelete) => {
    const updatedSkills = props.AlternateFieldValue.filter(
      (skill) => skill !== skillToDelete
    );
    props.setList(updatedSkills);
  };

  const handleAlternateInputChange = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent the default behavior of the Enter key

      const trimmedValue = e.target.value.trim(); // Trim any extra spaces

      if (trimmedValue !== "") {
        props.setList((prevSkills) => [...prevSkills, trimmedValue]);
        props.setFormData({
          ...props.FromData,
          [e.target.name]: "", // Clear the input box
        });
      }
    } else {
      props.setFormData({
        ...props.FromData,
        [e.target.name]: e.target.value,
      });
      if (e.target.value.endsWith(",")) {
        const trimmedValue = e.target.value.slice(0, -1).trim(); // Remove the comma and trim any extra spaces
        if (trimmedValue !== "") {
          props.setList((prevSkills) => [...prevSkills, trimmedValue]);
          props.setFormData({
            ...props.FromData,
            [e.target.name]: "", // Clear the input box
          });
        }
      }
    }
  };

  // Modified handleInputChange
  const handleInputChange = (e) => {
    let value = e.target.value;
    // (Optional) You can add any additional validations here.
    // For numeric fields, further sanitization is applied via event handlers below.
    props.onChange && props.onChange(e);
  };

  // Determine if this should be a numeric field
  const isNumeric = props.type === "number";
  // If numeric, force type to "text" (to avoid native type="number" issues)
  const inputType = isNumeric ? "text" : props.type || "text";

  return (
    <div
      className={`mb-3  ${
        props.mainclass
          ? props.mainclass + " common-input-field"
          : "common-input-field"
      }`}
    >
      {props.label && (
        <label
          htmlFor={`inputid-${props.index}`}
          className={`form-label ${
            props.labelclass ? props.labelclass + " form-label" : "form-label"
          }`}
        >
          {props.label}
        </label>
      )}
      <div className="common-input-sec">
        {props.field === "input" && (
          <input
            type={inputType}
            min={props.min}
            max={props.max}
            autoComplete={props.autoComplete}
            name={props.name}
            value={props.value}
            onFocus={props.onFocus}
            pattern={isNumeric ? "[0-9]*" : props.pattern}
            step={props.step}
            onChange={handleInputChange}
            onKeyUp={props.onKeyUp}
            placeholder={props.placeholder}
            valid={props.value}
            className={`form-control ${
              props.inputclass
                ? props.inputclass + " default-form-control"
                : "default-form-control"
            } ${props.valid && "is-invalid"}  ${props.success && "is-valid"}`}
            id={`inputid-${props.index}`}
            style={props.style}

            aria-describedby={`desc-text-${props.index} ${
              props.valid && `invalid-acs-${props.index}`
            }  ${props.success && `valid-acs-${props.index}`}`}
            readOnly={props.readonly ? true : false}
            {...(isNumeric && {
              inputMode: "numeric",
              // Block non-digit key presses (allow control keys)
              onKeyDown: (e) => {
                const allowedKeys = [
                  "Backspace",
                  "ArrowLeft",
                  "ArrowRight",
                  "Delete",
                  "Tab",
                ];
                if (allowedKeys.includes(e.key)) return;
                if (!/^\d$/.test(e.key)) {
                  e.preventDefault();
                }
              },
              // Prevent pasting non-digit content
              onPaste: (e) => {
                const pasteData = e.clipboardData.getData("text");
                if (!/^\d+$/.test(pasteData)) {
                  e.preventDefault();
                }
              },
              // Block any non-digit character before insertion
              onBeforeInput: (e) => {
                if (e.data && /[^0-9]/.test(e.data)) {
                  e.preventDefault();
                }
              },
            })}
          />
        )}

        {props.readonly && (
          <div className="readonly-icon">
            <i className="fa-solid fa-lock"></i>
          </div>
        )}
      </div>

      {props.field === "inputwithAlternate" && (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <input
            list={`datalist-${props.index}`}
            type={props.type || "text"}
            autoComplete={props.autoComplete}
            name={props.name}
            value={props.value}
            onChange={handleAlternateInputChange}
            onKeyDown={handleAlternateInputChange}
            placeholder={props.placeholder}
            valid={props.value}
            className={`form-control ${
              props.inputclass
                ? props.inputclass + " default-form-control"
                : "default-form-control"
            } ${props.valid && "is-invalid"}  ${props.success && "is-valid"}`}
            id={`inputid-${props.index}`}
            aria-describedby={`desc-text-${props.index} ${
              props.valid && `invalid-acs-${props.index}`
            }  ${props.success && `valid-acs-${props.index}`}`}
            readOnly={props.readonly ? true : false}
          />
          <datalist id={`datalist-${props.index}`}>
            {props.option &&
              props.option.map((res, index) => (
                <option key={index} value={res} />
              ))}
          </datalist>
        </div>
      )}

      {/* The rest of your component remains unchanged */}

      {props.field === "textarea" && (
        <textarea
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          placeholder={props.placeholder}
          maxLength={props.maxLength}
           style={props.style}
          className={`form-control ${
            props.inputclass ? props.inputclass : "default-form-control"
          } ${props.valid && "is-invalid"}  ${props.success && "is-valid"}`}
          aria-describedby={`desc-text-${props.index} ${
            props.valid && `invalid-acs-${props.index}`
          }  ${props.success && `valid-acs-${props.index}`}`}
          rows={props.rows || 4}
          id={`inputid-${props.index}`}
        />
      )}

      {props.field === "datalist" && (
        <>
          <input
            list={`datalist-${props.index}`}
            placeholder={props.placeholder}
            name={props.name}
            value={props.value}
            onChange={props.onChange}
            className={`form-control ${
              props.inputclass
                ? props.inputclass + " default-form-control"
                : "default-form-control"
            } ${props.valid && "is-invalid"}  ${props.success && "is-valid"}`}
            id={`inputid-${props.index}`}
          />
          <datalist id={`datalist-${props.index}`}>
            {props.option &&
              props.option.map((res, index) => (
                <option key={index} value={res} />
              ))}
          </datalist>
        </>
      )}

      {props.field === "select" && (
        <select
          name={props.name}
          value={props.value || ""}
          onChange={props.onChange}
          style={props.style}
          className={`form-control ${
            props.inputclass ? props.inputclass : "default-form-control"
          } ${props.valid && "is-invalid"} ${props.success && "is-valid"}  ${
            props.value ? "selectdropDownoption" : "selectemptyoption"
          }`}
          aria-describedby={`desc-text-${props.index} ${
            props.valid && `invalid-acs-${props.index}`
          } ${props.success && `valid-acs-${props.index}`}`}
          id={`inputid-${props.index}`}
        >
          {props.defaultoption && (
            <option value="" className="selectemptyoption">
              {props.defaultoption}
            </option>
          )}
          {props.schoolList
            ? props.option &&
              props.option.map((res, index) => (
                <option key={index} value={props.resource ? res : res?.id}>
                  {`(${res?.school_code})-${res?.name}`}
                </option>
              ))
            : props.option &&
              props.option.map((res, index) => (
                <option
                  className="selectoption"
                  key={index}
                  value={props.resource ? res : res?.id}
                >
                  {props.resource
                    ? res
                    : res?.name
                    ? res?.name
                    : res?.username}
                </option>
              ))}
        </select>
      )}

      {props.field === "searchabledropdown" && (
        <CommonDropdown
          name={props.name}
          value={props.value || ""}
          onChange={props.onChange}
           isMulti={props.isMulti}

          valid={props.valid}
          success={props.success}
          index={props.index}
          options={props.option}
          placeholder={props.defaultoption}
        />
      )}
        {props.field === "searchableMultidropdown" && (
        <CommonMultipleDropdown
          name={props.name}
          value={props.value || ""}
          onChange={props.onChange}
           isMulti={props.isMulti}

          valid={props.valid}
          success={props.success}
          index={props.index}
          options={props.option}
          placeholder={props.placeholder}
        />
      )}

      {props.field === "date" && (
        <input
          type="date"
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          placeholder={props.placeholder}
          className={`form-control ${
            props.inputclass
              ? props.inputclass + " default-form-control"
              : "default-form-control"
          } ${props.valid && "is-invalid"}  ${props.success && "is-valid"} ${
            props.value ? "InputDateselectColor" : "InputDateColor"
          }`}
          id={`inputid-${props.index}`}
          readOnly={props.readonly ? true : false}
        />
      )}

      {props.field === "file" && (
        <input
          type="file"
          name={props.name}
          value={props.value}
          onChange={props.onChange}
          placeholder={props.placeholder}
          className={`form-control ${
            props.inputclass
              ? props.inputclass + " default-form-control"
              : "default-form-control"
          } ${props.valid && "is-invalid"}  ${props.success && "is-valid"}`}
          id={`inputid-${props.index}`}
          accept={props.accept}
          multiple={props?.multiple}
        />
      )}

      {props.field === "fileDoc" && (
        <div className={"fileUpload"}>
          <i className={`fa-solid fa-cloud-arrow-up uploadIcon`}></i>
          <input
            type="file"
            disabled={props.readonly}
            accept={props.accept}
            onChange={props.onChange}
            style={{ display: "none" }}
            id={`image-upload-${props.index}`}
          />
          <label
            htmlFor={`image-upload-${props.index}`}
            className={`form-placeholder ${
              props.imagelabelclass
                ? props.imagelabelclass + " form-placeholder"
                : ""
            }`}
          >
            {props.placeholder}
          </label>
          {props.selectedImage && (
            <div className={"imagePreview"}>
              <img
                src={props.selectedImage}
                alt="Preview"
                className={"previewImage"}
              />
            </div>
          )}
        </div>
      )}

      {props.valid && (
        <div
          className="invalid-feedback"
          style={{ display: props.readonly ? "none" : "block" }}
          id={`invalid-acs-${props.index}`}
        >
          {props.valid}
        </div>
      )}
      {props.success && (
        <div
          className="valid-feedback"
          style={{ display: props.success ? "block" : "none" }}
          id={`valid-acs-${props.index}`}
        >
          {props.success}
        </div>
      )}
      {props.description && (
        <div
          id={`desc-text-${props.index}`}
          style={{ display: props.description ? "block" : "none" }}
          className="form-text"
        >
          {props.description}
        </div>
      )}
      {props.field === "inputwithAlternate" && (
        <div className="alternate">
          {props.AlternateFieldValue?.map((res, index) => (
            <div key={index} className="alternate-box border rounded">
              {res}
              <span className="close-btn" onClick={() => handleDelete(res)}>
                &times;
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CommonInputField;
